export default __webpack_public_path__ + "static/media/01_B.e17fa037.png";